export const datepicker = {
  width: 'auto',
  minWidth: '228px',
  maxWidth: '270px',
  position: 'absolute',
  right: 0,
  marginTop: 'xs',
  padding: 'xs',
  borderRadius: '5px',
  boxShadow: 'rgba(0, 0, 0, 0.4) 0px 0px 16px 0px',
  variants: {
    primary: {
      backgroundColor: 'rgb(27, 33, 41)',
      color: 'white',
    },
    secondary: {
      background: 'grey',
      color: 'white',
    },
  },
};

export const datepickerSelector = {
  height: '230px',
  justifyContent: 'center',
  alignItems: 'center',
};

export const datepickerHeader = {
  width: '100%',
  padding: '0 0 8px',
  borderBottom: '1px solid grey',
  textTransform: 'capitalize',
  states: {
    '& .action': {
      display: 'flex',
      justifyContent: 'center',
      cursor: 'pointer',
      padding: '8px',
      margin: '0 4px',
      borderRadius: '4px',
    },
    '& .action:hover': {
      background: 'grey',
    },
    '& .right': {
      marginLeft: 'auto',
    },
    '& .left': {
      marginRight: 'auto',
    },
  },
};

export const datepickerDays = {
  states: {
    '& > div:hover': {
      background: 'rgb(25, 126, 247)',
    },
  },
};

export const datepickerArrows = {
  margin: 0,
};

export const datepickerSingleDay = {
  height: '28px',
  width: '28px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
};

export const datePickerDaysNames = {
  width: '28px',
  height: '28px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
};
